import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Pimplesaudagartomumbai() {



  const cardData =
  {
    keyword: ' Pimple Saudagar to Mumbai Cab Service',
    heading: 'Sai Trupti Cabs: Pimple Saudagar to Mumbai Cab Service',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pimple Saudagar to Mumbai cab services, ensuring a safe and enjoyable journey for every traveler. Our fleet of clean, air-conditioned Sedans, SUVs, and Luxury vehicles is designed to provide maximum comfort and convenience for families, professionals, and solo passengers alike. With experienced, background-verified chauffeurs, you can expect punctual pickups, courteous service, and smooth driving all the way to your destination—whether it’s Mumbai city, Navi Mumbai, or Mumbai Airport. Sai Trupti Cabs guarantees transparent pricing, flexible one-way and round-trip options, and 24×7 customer support for complete peace of mind. Experience effortless and reliable intercity travel from Pimple Saudagar to Mumbai with Sai Trupti Cabs — your trusted partner for comfortable and affordable taxi services.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Pimple Saudagar to Mumbai Cab Service",
    "description": "Pimple Saudagar to Mumbai Cab Service offers reliable and comfortable intercity travel with a focus on safety, punctuality, and convenience. Featuring a fleet of well-maintained vehicles and professional drivers, this service caters to business travelers, families, and airport passengers. With transparent pricing, online booking options, and 24/7 customer support, passengers can enjoy a seamless and stress-free journey between Pimple Saudagar and Mumbai."
  },
  {
    "name": "Pimple Saudagar to Mumbai Taxi",
    "description": "Pimple Saudagar to Mumbai Taxi provides convenient and secure transportation for travelers commuting between Pimple Saudagar and Mumbai. The service features trained drivers, clean vehicles, and door-to-door service, ensuring a comfortable and hassle-free ride. Online booking, real-time tracking, and multiple payment options make it ideal for both business and leisure travel."
  },
  {
    "name": "Pimple Saudagar to Mumbai Car Hire",
    "description": "Pimple Saudagar to Mumbai Car Hire offers a variety of vehicles for intercity travel, including hatchbacks, sedans, and SUVs. Customers can choose between self-drive or chauffeur-driven options, providing maximum flexibility and comfort. The service ensures well-maintained vehicles, professional drivers, transparent fares, and 24/7 online booking for a seamless travel experience."
  },
  {
    "name": "Pimple Saudagar to Mumbai Innova Cab",
    "description": "Pimple Saudagar to Mumbai Innova Cab provides spacious and comfortable Toyota Innova vehicles, ideal for families and small groups. With air-conditioned interiors, ample seating, and experienced drivers, passengers can enjoy a safe and smooth journey. Online booking, fare transparency, and reliable customer support make this service perfect for intercity travel."
  },
  {
    "name": "Pimple Saudagar to Mumbai Ertiga Cab",
    "description": "Pimple Saudagar to Mumbai Ertiga Cab features Maruti Ertiga vehicles suitable for medium-sized groups traveling to Mumbai. The service offers comfortable seating, air-conditioned interiors, and professional drivers familiar with the route. Online booking, 24/7 assistance, and transparent fares ensure a dependable and convenient travel experience."
  },
  {
    "name": "Pimple Saudagar to Mumbai Sedan Cab",
    "description": "Pimple Saudagar to Mumbai Sedan Cab provides mid-sized sedans for a smooth and comfortable intercity travel experience. Ideal for business trips, small families, or solo travelers, the service includes air-conditioned vehicles, sufficient luggage space, and professional drivers. Online booking and transparent pricing enhance convenience and reliability."
  },
  {
    "name": "Pimple Saudagar to Mumbai One Way Taxi",
    "description": "Pimple Saudagar to Mumbai One Way Taxi offers economical and efficient single-trip services for travelers who do not require a return journey. Featuring professional drivers and well-maintained air-conditioned vehicles, this service ensures punctual pickups, safety, and comfort. Online booking and transparent fares make it a cost-effective and reliable choice for intercity travel."
  },
  {
    "name": "Pimple Saudagar to Mumbai Drop Cab",
    "description": "Pimple Saudagar to Mumbai Drop Cab specializes in one-way drop services for seamless intercity travel. The service provides a variety of vehicles, including sedans and SUVs, driven by experienced professionals familiar with the route. Passengers enjoy safe, comfortable, and timely travel, with online booking and 24/7 customer support adding convenience."
  },
  {
    "name": "Pimple Saudagar to Mumbai Airport Taxi",
    "description": "Pimple Saudagar to Mumbai Airport Taxi offers dedicated airport transfers for travelers heading to or from Mumbai airports. With punctual pickups, professional drivers, and comfortable air-conditioned vehicles, the service ensures a stress-free travel experience. Online booking, fare transparency, and real-time tracking enhance convenience for both domestic and international travelers."
  },
  {
    "name": "Pimple Saudagar to Mumbai Outstation Cab",
    "description": "Pimple Saudagar to Mumbai Outstation Cab provides intercity travel solutions for long-distance trips. Well-maintained vehicles, professional drivers, and route knowledge ensure safety, comfort, and timeliness. Online booking, transparent fares, and 24/7 support make it suitable for business travelers, families, and tourists seeking a reliable travel experience."
  },
  {
    "name": "Affordable Pimple Saudagar to Mumbai Taxi",
    "description": "Affordable Pimple Saudagar to Mumbai Taxi offers cost-effective travel solutions for passengers seeking budget-friendly options. Without compromising on safety or comfort, the service provides clean vehicles, professional drivers, and transparent pricing. Online booking and 24/7 support make it a convenient choice for students, families, and frequent travelers."
  },
  {
    "name": "Pimple Saudagar to Mumbai Luxury Cab",
    "description": "Pimple Saudagar to Mumbai Luxury Cab caters to travelers desiring a premium experience. Featuring high-end vehicles such as BMW, Mercedes, and Audi, this service ensures luxurious interiors, professional chauffeurs, and top-tier comfort. Online booking, transparent fares, and 24/7 support offer a seamless and elegant journey for VIP clients and business executives."
  },
  {
    "name": "Pimple Saudagar to Mumbai Cab Booking Online",
    "description": "Pimple Saudagar to Mumbai Cab Booking Online allows customers to reserve cabs digitally with ease and convenience. Users can select vehicle types, schedule pickups, receive instant confirmations, and manage bookings through a user-friendly platform. Real-time tracking, transparent fares, and 24/7 support ensure a smooth and reliable intercity travel experience."
  },
  {
    "name": "Pimple Saudagar to Mumbai Taxi near Me",
    "description": "Pimple Saudagar to Mumbai Taxi near Me offers quick access to nearby cabs for immediate or scheduled travel to Mumbai. The service features professional drivers, well-maintained vehicles, and fast booking options. Transparent pricing, comfortable rides, and 24/7 assistance ensure convenient and reliable transportation for airport transfers, business trips, or personal travel."
  },
  {
    "name": "Pimple Saudagar to Mumbai Travel Service",
    "description": "Pimple Saudagar to Mumbai Travel Service provides comprehensive intercity travel solutions, including one-way and round trips, airport transfers, and group travel. The service emphasizes safety, comfort, and punctuality, with well-maintained vehicles and experienced drivers. Online booking, transparent fares, and 24/7 customer support make it a dependable choice for travelers seeking hassle-free transportation."
  }
],
"tableData": [
  ["Pimple Saudagar to Mumbai Cab Service", "Pimple Saudagar to Mumbai Taxi"],
  ["Pimple Saudagar to Mumbai Car Hire", "Pimple Saudagar to Mumbai Innova Cab"],
  ["Pimple Saudagar to Mumbai Ertiga Cab", "Pimple Saudagar to Mumbai Sedan Cab"],
  ["Pimple Saudagar to Mumbai One Way Taxi", "Pimple Saudagar to Mumbai Drop Cab"],
  ["Pimple Saudagar to Mumbai Airport Taxi", "Pimple Saudagar to Mumbai Outstation Cab"],
  ["Affordable Pimple Saudagar to Mumbai Taxi", "Pimple Saudagar to Mumbai Luxury Cab"],
  ["Pimple Saudagar to Mumbai Cab Booking Online", "Pimple Saudagar to Mumbai Taxi near Me"],
  ["Pimple Saudagar to Mumbai Travel Service", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pimple Saudagar to Mumbai Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers reliable and comfortable cab services from Pimple Saudagar (Pune) to Mumbai, ideal for business trips, airport transfers or leisure travel."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Fare",
    "WhyChoosedescription": "We provide clear one‑way fares from Pimple Saudagar to Mumbai with no hidden charges—what you see is what you pay."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage and comfort preferences for the Pimple Saudagar‑to‑Mumbai route."
  },
  {
    "WhyChooseheading": "Experienced & Punctual Drivers",
    "WhyChoosedescription": "Our courteous, professional drivers know the Pimple Saudagar to Mumbai route well and ensure a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop‑off Locations",
    "WhyChoosedescription": "We facilitate convenient pickups in Pimple Saudagar (and surrounding Pune suburbs) and drop‑offs across Mumbai — including airports, railway stations and city spots."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized and prepared for long‑distance travel between Pimple Saudagar and Mumbai for maximum comfort."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, modifications or travel queries."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Pimple Saudagar to Mumbai cab easily via call, WhatsApp or our website — with instant confirmation and prompt dispatch."
  }
]























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pimple Saudagar to Mumbai cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pimple Saudagar to Mumbai cab services for one way, round trip, and airport transfers.',
  },
  {
    question: 'How can I book a Pimple Saudagar to Mumbai cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pimple Saudagar to Mumbai cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pimple Saudagar to Mumbai?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and luxury cars to meet your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for the Pimple Saudagar to Mumbai route?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in driving on the Pimple Saudagar–Mumbai route, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I book a Pimple Saudagar to Mumbai cab for airport transfers?',
    answer: 'Certainly. We provide dedicated Pimple Saudagar to Mumbai airport cab services with timely pickup and drop-off for both domestic and international terminals.',
  },
  {
    question: 'Is the Pimple Saudagar to Mumbai cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Pimple Saudagar to Mumbai for your convenience and travel flexibility.',
  },
  {
    question: 'What are the Pimple Saudagar to Mumbai cab fares?',
    answer: 'Our cab fares start from ₹1,800 for hatchbacks, ₹2,100–₹2,900 for sedans, and ₹3,500 onwards for SUVs, depending on vehicle type and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pimple Saudagar to Mumbai cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pimple Saudagar to Mumbai cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers strictly follow hygiene and safety measures to ensure a safe journey.',
  },
  {
    question: 'Is customer support available during the Pimple Saudagar to Mumbai cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pimple Saudagar to Mumbai cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nilesh Patil',
    feedback: 'I booked a Pimple Saudagar to Mumbai cab with Sai Trupti Cabs. The car was comfortable and the driver was punctual and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Aarti More',
    feedback: 'Sai Trupti Cabs made my Pimple Saudagar to Mumbai trip smooth and hassle-free. Excellent service and timely pickup!',
    rating: 5,
  },
];

























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimple Saudagar to Mumbai Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pimple-saudagar-to-mumbai-cab.jpg",
  "description": "Book Pimple Saudagar to Mumbai Cab Service with Sai Trupti Cabs for a safe, reliable, and affordable journey. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, airport transfers, or outstation travel. Enjoy 24/7 online booking, verified drivers, and on-time service from Pimple Saudagar to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15340"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2399",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pimple-saudagar-to-mumbai-cab-service"
  }
};






  return (
    <div>
      <Helmet>
  <title>Pimple Saudagar to Mumbai Cab Service | Affordable & Reliable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pimple Saudagar to Mumbai Cab Service with Sai Trupti Cabs for a safe, reliable, and affordable journey. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, airport transfers, or outstation travel. Enjoy 24/7 online booking, verified drivers, and on-time service from Pimple Saudagar to Mumbai." 
  />
  <meta 
    name="keywords" 
    content="Pimple Saudagar to Mumbai Cab Service, Pimple Saudagar to Mumbai Taxi, Pimple Saudagar to Mumbai Car Hire, Pimple Saudagar to Mumbai Innova Cab, Pimple Saudagar to Mumbai Ertiga Cab, Pimple Saudagar to Mumbai Sedan Cab, Pimple Saudagar to Mumbai One Way Taxi, Pimple Saudagar to Mumbai Drop Cab, Pimple Saudagar to Mumbai Airport Taxi, Pimple Saudagar to Mumbai Outstation Cab, Affordable Pimple Saudagar to Mumbai Taxi, Pimple Saudagar to Mumbai Luxury Cab, Pimple Saudagar to Mumbai Cab Booking Online, Pimple Saudagar to Mumbai Taxi near Me, Pimple Saudagar to Mumbai Travel Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Pimplesaudagartomumbai;